<div id="ReasonListModal" *ngIf="surveyService.showReasonListModal" class="Table-Cont" >
    <div class="Reason-List-Div">
        <div class="text-end">
            <img 
            class="cross-img" 
            src="../../../../../assets/media/icons/close_black.png" 
            alt="" 
            (click)="reasonModalPopupClose()"
            />
        </div>
        <div class="downloadList">
            <div class="text-dark fs-4 fw-bold">
                Reasons List
            </div>
            <div>
                <button class="down-btn" (click)="downloadReasonList()">Download</button>
            </div>
        </div>
    </div>
    <div *ngIf="reasonList.length > 0" class="table-responsive table-div bg-light">
        <table class="table">
            <thead>
                <div class="Table-row bg-white Table-row-head">
                    <div class="fs-5 text-dark fw-bold">SI No.</div>
                    <div class="fs-5 fw-bold text-dark">Reasons</div>
                    <div class="fs-5 fw-bold text-dark">Brief</div>
                    <div class="fs-5 fw-bold text-dark">Cases</div>
                </div>
            </thead>
            <tbody>
                <ng-container *ngFor="let list of reasonList; let i=index">
                    <div class="Table-row bg-white Table-row-body">
                        <div class="fs-7 text-dark fw-bold ">{{i+1+"."}}</div>
                        <div class="fs-7 text-dark fw-bold">{{list['label']}}</div>
                        <div class="fs-7 text-dark fw-bold">{{list['brief']}}</div>
                        <div>
                            <ng-container *ngFor="let case of list['cases']; let v=index">
                                <div class="Case-div">
                                    <div class="text-dark fw-bold">{{v+1+"."}}</div>
                                    <div class="fs-7 text-dark ms-2 fw-bold">
                                        {{case}}
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>



<div *ngIf="surveyService.showCagsDeatilsModal">
    <div class="text-dark fs-4 fw-bold text-center">
        Cags Deatils
    </div>
    <div class="cags-text-end">
        <img 
        class="cross-img" 
        src="../../../../../assets/media/icons/close_black.png" 
        alt="" 
        (click)="cagsDetailsPopupClose()"
        />
    </div>
    <div class="bg-white px-3 cags-div">
        <ng-container *ngFor="let Item of CagsDeatails">
            <div class="cags-inner-div">
                <div class="fs-5 fw-bold text-dark">{{Item.name | titlecase}}</div>
                <div class="cags-form text-dark fs-6 fw-bold">
                    {{Item.val.join(",")}}
              

                </div>
            </div>
        </ng-container>
    </div>
</div>


<div *ngIf="surveyService.paymentStatusModalOpen">
    <div class="text-dark fs-4 fw-bold text-center mb-3">
        Payment Status
    </div>
    <div class="cags-text-end">
        <img 
        class="cross-img" 
        src="../../../../../assets/media/icons/close_black.png" 
        alt="" 
        (click)="cagsDetailsPopupClose()"
        />
    </div>


    <div *ngIf="paymentStatus.length > 0" class="table-responsive table-div-1 bg-light">
        <table class="table">
            <thead>
                <div [ngStyle]="{'display':'grid','grid-template-columns':SetGridColum('payment'),'margin':'10px 5px -5px 15px','padding':'0px 10px','border':'1px solid #e1e1e1','align-items': 'flex-start'}" class="bg-white Table-row-head">
                    <ng-container *ngFor="let Head of paymentStatusHeader">
                        <div class="fs-5 text-dark fw-bold">{{Head | titlecase}}</div>
                    </ng-container>
                </div>
            </thead>
            <tbody>
                <ng-container *ngFor="let list of paymentStatus; let i=index">
                    <div 
                    [ngStyle]="{'display':'grid','grid-template-columns':SetGridColum('payment'),'margin':'10px 5px -5px 15px','padding':'0px 10px','border':'1px solid #e1e1e1','align-items': 'flex-start'}" 
                    class="bg-white Table-row-body">
                        <div class="fs-6 text-dark fw-bold ">{{(i+1) + "."}}</div>
                        <div class="fs-6 text-dark fw-bold">{{list['status']}}</div>
                        <div class="fs-6 text-dark fw-bold">{{list['date']}}</div>
                        <div class="fs-6 text-dark fw-bold">{{list['reason'] || 'NA' }}</div>
                    </div>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>



<div *ngIf="surveyService.responseStatusModalOpen">
    <div class="text-dark fs-4 fw-bold text-center mb-3">
        Response Status
    </div>
    <div class="cags-text-end">
        <img 
        class="cross-img" 
        src="../../../../../assets/media/icons/close_black.png" 
        alt="" 
        (click)="cagsDetailsPopupClose()"
        />
    </div>

    <div *ngIf="ResponseStatus.length > 0" class="table-responsive table-div-1 bg-light">
        <table class="table">
            <thead>
                <div
                [ngStyle]="{'display':'grid','grid-template-columns':SetGridColum('response'),'margin':'10px 5px -5px 15px','padding':'0px 10px','border':'1px solid #e1e1e1','align-items': 'flex-start'}"
                class="bg-white Table-row-head">
                    <ng-container *ngFor="let Head of ResponseStatusHeader">
                        <div class="fs-5 text-dark fw-bold">{{Head | titlecase}}</div>
                    </ng-container>
                </div>
            </thead>
            <tbody>
                <ng-container *ngFor="let list of ResponseStatus; let i=index">
                    <div
                    [ngStyle]="{'display':'grid','grid-template-columns':SetGridColum('response'),'margin':'10px 5px -5px 15px','padding':'0px 10px','border':'1px solid #e1e1e1','align-items': 'flex-start'}"
                    class="bg-white Table-row-body">
                        <div class="fs-6 text-dark fw-bold ">{{(i+1) + "."}}</div>
                        <div class="fs-6 text-dark fw-bold">{{list['status']}}</div>
                        <div class="fs-6 text-dark fw-bold">{{list['date']}}</div>
                        <div class="fs-6 text-dark fw-bold">{{list['reason'] || 'NA'}}</div>
                    </div>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>